import React from 'react';

import CompanyHome from '../CompanyRoutes/CompanyHomepage/CompanyHome.component.jsx';

// Create
import UploadForm from '../CompanyRoutes/CreateRoutes/UploadForm/UploadForms.component.jsx';
import CreateSubcontractor from '../CompanyRoutes/CreateRoutes/CreateSubContractor/Subcontractor.component.jsx';
import CreateManagerCompany from '../CompanyRoutes/CreateRoutes/CreateManagerEmployee/CreateME.component.jsx';

// Payments
import CompleteTransactionCompany from '../CompanyRoutes/CompanyBuyCourses/TransactionComplete/CompleteTransactionCompany.component.jsx';
import PurchaseHistory from '../CompanyRoutes/PurchaseHistory/PurchasedHistory.component.jsx';
import CompanyPurchaseCourses from '../CompanyRoutes/CompanyBuyCourses/CompanyBuyCourse.component.jsx';
import CompanyPurchasedCoursesList from '../CompanyRoutes/PurchasedCourses/TrainingList.component.jsx';

// Edit
// import EditManagerOrEmployee from '../AdminRoutes/EditRoutes/EditManagers/MEBasePage/EditManagerOrEmployee.jsx';
import EditForm from '../CompanyRoutes/EditRoutes/EditForm/EditForms.component.jsx';

// Users
// import UserCourseDetails from '../AdminRoutes/EditRoutes/EditUser/UserCoursesPage/UserCourseDetails.component.jsx';
import CompanyEmployeesPage from '../CompanyRoutes/CompanyHomepage/CompanyEmployees.component.jsx';

// Forms
import CompanyFormsPage from '../CompanyRoutes/CompanyHomepage/CompanyForms.component.jsx';

// Settings
import CompanySettingsPage from '../CompanyRoutes/CompanySetting/CompanySettings.component.jsx';

export const companyRoutes = [
  { path: '', element: <CompanyHome /> },
  { path: 'upload-form/:id', element: <UploadForm /> },
  // {
  //   path: 'edit-manager-employee/:userId',
  //   element: <EditManagerOrEmployee />,
  // },
  { path: 'create-manager-employee/:id', element: <CreateManagerCompany /> },
  { path: 'purchase-history/:id', element: <PurchaseHistory /> },
  { path: 'create-subcontractor/:id', element: <CreateSubcontractor /> },
  // {
  //   path: 'certificate/:id/course/:courseId',
  //   element: <UserCourseDetails />,
  // },
  { path: 'training-list/:id', element: <CompanyPurchasedCoursesList /> },
  { path: 'buy-courses/:companyId', element: <CompanyPurchaseCourses /> },
  { path: 'transaction-completed', element: <CompleteTransactionCompany /> },
  { path: 'forms/:id', element: <CompanyFormsPage /> },
  { path: 'employees/:id', element: <CompanyEmployeesPage /> },
  { path: 'settings/:id', element: <CompanySettingsPage /> },
  { path: ':id/edit-form/:formId', element: <EditForm /> },
];
